// extracted by mini-css-extract-plugin
export default {"block-card":"styles_block-card__3peSd"};